import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import ReadingMask from "../../ReadingMask";
import { BiAccessibility } from "react-icons/bi";
import PageStructure from "../../PageStructure/PageStructure";
import { translation } from "../../Language";
const Bootstrap = React.forwardRef(({ children, mouseYPosition = 0, isOpen = false, classes = [], handleMouseMove = () => { }, setIsOpen = () => { }, links = [], headings = [], handleReset = () => { }, language = "en", features = [], resetDisabled = false, }, ref) => {
    const bigCursor = features.filter((f) => f.featureName === "BIG_CURSOR" /* Types.BIG_CURSOR */).length > 0 &&
        features.filter((f) => f.featureName === "BIG_CURSOR" /* Types.BIG_CURSOR */)[0].feature;
    const readingMask = features.filter((f) => f.featureName === "READING_MASK" /* Types.READING_MASK */).length > 0 &&
        features.filter((f) => f.featureName === "READING_MASK" /* Types.READING_MASK */)[0].feature;
    return (React.createElement(Container, { fluid: true, className: bigCursor ? "cursor" : "", onMouseMove: (event) => handleMouseMove(event), style: {
            maxWidth: "100vw",
            minHeight: "100vh",
        }, ref: ref },
        readingMask && (React.createElement(ReadingMask, { mousePosition: mouseYPosition })),
        isOpen && (React.createElement(Container, { className: "left-bar", style: {
                border: "1px solid gray",
                backgroundColor: "#eff1f5",
                zIndex: 9999,
                top: 0,
                left: 0,
                overflow: "auto",
                height: "100%",
                width: "40%",
            } },
            React.createElement(Row, null,
                React.createElement(Col, { md: 12, sm: 12, style: {
                        marginBottom: "5px",
                    } },
                    React.createElement(Row, null,
                        React.createElement(Col, { md: 6, sm: 12, style: {
                                textAlign: "left",
                            } },
                            React.createElement("span", null,
                                translation[language].accessibilityMenu,
                                "(ctrl + u)")),
                        React.createElement(Col, { md: 6, sm: 12, style: {
                                textAlign: "right",
                            } },
                            React.createElement(Button, { onClick: () => handleReset(), disabled: resetDisabled, "aria-label": translation[language].reset }, translation[language].reset)))),
                features.map((f, index) => (React.createElement(Col, { md: 6, sm: 12 },
                    React.createElement(Button, { className: `accessibility-button mb-1`, variant: f.feature ? "primary" : "outline-dark", size: "lg", onClick: () => f.handler(), style: {
                            cursor: bigCursor ? "inherit" : "pointer",
                            minHeight: "125px",
                            height: "auto",
                            borderRadius: "20px",
                            padding: "inherit",
                            width: "100%",
                            textOverflow: "ellipsis",
                        }, "aria-label": f.text, tabIndex: index + 1 },
                        React.createElement(Container, null,
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 12, className: "mb-3" }, f.icon),
                                React.createElement(Col, { xs: 12 },
                                    React.createElement("span", null, f.text))))))))))),
        React.createElement(Button, { onClick: () => setIsOpen(!isOpen), style: {
                cursor: bigCursor ? "inherit" : "pointer",
                left: isOpen ? "41%" : "0",
                color: "black",
                position: "fixed",
            }, variant: "outline", className: "disabled-person-button" },
            React.createElement(BiAccessibility, { size: 30 })),
        React.createElement(Container, { className: classes.join(" ") }, children),
        features.filter((f) => f.featureName === "PAGE_STRUCTURE" /* Types.PAGE_STRUCTURE */).length >
            0 && (React.createElement(PageStructure, { isOpen: features.filter((f) => f.featureName === "PAGE_STRUCTURE" /* Types.PAGE_STRUCTURE */)[0]
                .feature, links: links, headings: headings, onClose: features.filter((f) => f.featureName === "PAGE_STRUCTURE" /* Types.PAGE_STRUCTURE */)[0]
                .handler, language: language, bigCursor: bigCursor }))));
});
export default Bootstrap;
//# sourceMappingURL=Bootstrap.js.map